import * as React from "react";
import "@aws-amplify/ui-react/styles.css";

import { Authenticator } from "@aws-amplify/ui-react";
import { Switch, Route, Link } from "react-router-dom";

import { SignOutLink } from "components/SignOutButton";

import { PrintFileDetailPage } from "./printfiles/PrintFileDetailPage";
// import { PrintFileListPage } from "./printfiles/PrintFileListPage";
import { DatasetListPage } from "./datasets/DatasetListPage";
import { DatasetDetailPage } from "./datasets/DatasetDetailPage";
import { MLModelDetailPage } from "./mlmodels/MLModelDetailPage";
import { MLModelResultDetailPage } from "./mlmodels/MLModelResultDetailPage";
import { MLModelListPage } from "./mlmodels/MLModelListPage";
import { ModelSearchListPage } from "./modelsearch/ModelSearchListPage";
import { ModelSearchDetailPage } from "./modelsearch/ModelSearchDetailPage";
import { SubmissionListPage } from "./submissions/SubmissionListPage";
import { SubmissionDetailPage } from "./submissions/SubmissionDetailPage";

import { PrintResultDetailPage } from "./printfiles/PrintResultDetailPage";

import { Layout, Row, Col } from "antd";
import { useAmplifyOrgSubscriptionPublisher, AmplifyPubSubContext } from "api";

const { Header } = Layout;

/**
 * AuthedRouterPage Component
 * 
 * Main authenticated router component that handles user authentication and routing
 * for all authenticated pages in the application. Provides the main navigation
 * header and routes to different sections of the app.
 * 
 * Features:
 * - AWS Amplify authentication integration
 * - Main navigation header with links to all sections
 * - Route configuration for all authenticated pages
 * - Organization-based subscription context
 * - Sign out functionality
 * 
 * @returns {JSX.Element} The authenticated router component
 */
export const AuthedRouterPage = () => {
  return (
    <Authenticator hideSignUp={true}>
      {({ user }) => {
        const session = user.getSignInUserSession();
        console.log(session);
        if (!session) throw new Error("SignInSession is empty!");
        return <AuthenticatedSessionView session={session} />;
      }}
    </Authenticator>
  );
};

/**
 * AuthenticatedSessionView Component
 * 
 * Internal component that renders the authenticated session view with navigation
 * and routing. This component is only rendered after successful authentication.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.session - The authenticated user session
 * @returns {JSX.Element} The authenticated session view
 */
function AuthenticatedSessionView(props) {
  const { session } = props;
  const orgId = session.idToken?.payload?.orgId;
  const amplifyPubSubContext = useAmplifyOrgSubscriptionPublisher(orgId);

  return (
    <div>
      <Layout>
        <Header className="header">
          <Row>
            <div className="logo" />
            {/* <Col flex="100px">
              <Link to={`/printfiles`}>Print Files</Link>
            </Col> */}
            <Col flex="100px">
              <Link to={`/`}>Datasets</Link>
            </Col>
            <Col flex="100px">
              <Link to={`/mlmodels`}>ML Models</Link>
            </Col>
            <Col flex="100px">
              <Link to={`/submissions`}>Submissions</Link>
            </Col>
            <Col flex="auto">
              <Link to={`/modelsearch`}>Model Search</Link>
            </Col>
            <Col flex="100px" style={{ align: "right" }}>
              <SignOutLink />
            </Col>
          </Row>
        </Header>
      </Layout>
      <div>
        <AmplifyPubSubContext.Provider value={amplifyPubSubContext}>
          <Switch>
            <Route path="/printfiles/:modelId/result/:printResultId">
              <PrintResultDetailPage />
            </Route>
            <Route path="/printfiles/:modelId">
              <PrintFileDetailPage />
            </Route>
            <Route path="/datasets/:datasetId">
              <DatasetDetailPage />
            </Route>
            <Route path="/datasets">
              <DatasetListPage />
            </Route>
            <Route path="/mlmodels/:mlmodelId/result/:resultId">
              <MLModelResultDetailPage />
            </Route>
            <Route path="/mlmodels/:mlmodelId">
              <MLModelDetailPage />
            </Route>
            <Route path="/mlmodels">
              <MLModelListPage />
            </Route>
            <Route path="/submissions/:submissionId">
              <SubmissionDetailPage />
            </Route>
            <Route path="/submissions">
              <SubmissionListPage />
            </Route>
            <Route path="/modelsearch/:partVectorSearchId">
              <ModelSearchDetailPage />
            </Route>
            <Route path="/modelsearch">
              <ModelSearchListPage />
            </Route>
            <Route path="/">
              {/* <PrintFileListPage /> */}
              <DatasetListPage />
            </Route>
          </Switch>
        </AmplifyPubSubContext.Provider>
      </div>
    </div>
  );
}
